import React, { useRef } from "react"
import Modal from "../components/Modal"
import { ExtendedApplicationDoc } from "../types/applicationData"

interface EditStatePayloadProps {
  modalOpen: boolean
  onClose: () => void
  postUrl: string
  setPostUrl: React.Dispatch<React.SetStateAction<string>>
  handleSaveStatePayload: (application: ExtendedApplicationDoc) => void
  handleCloseModal: () => void
  application: ExtendedApplicationDoc
}

const EditStatePayload: React.FC<EditStatePayloadProps> = ({
  modalOpen,
  onClose,
  postUrl,
  setPostUrl,
  handleSaveStatePayload,
  handleCloseModal,
  application,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  return modalOpen ? (
    <div className="flex h-full items-center justify-center absolute">
      <Modal
        onClick={onClose}
        classname="fixed inset-0 bg-gray-600 bg-opacity-50 p-3 flex items-center justify-center z-50"
        classname2="relative bg-white rounded-3xl w-1/3"
      >
        <div className="bg-white rounded-3xl p-6" onClick={(e) => e.stopPropagation()}>
          <h2 className="text-lg font-semibold mb-4">Post Verilerini Düzenle</h2>

          <div className="space-y-2">
            <label htmlFor="statePayload" className="text-sm text-neutral-700">
              JSON Verisi (Beğeni, Yorum, Gösterim vb.)
            </label>

            <div className="relative">
              <textarea
                ref={textareaRef}
                id="statePayload"
                className="block w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none font-mono text-sm"
                rows={6}
                placeholder="https://www.instagram.com/p/DNJPCfno8s3"
                value={postUrl}
                onChange={(e) => setPostUrl(e.target.value)}
              />
            </div>
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 cursor-pointer"
              onClick={handleCloseModal}
            >
              Kapat
            </button>

            <button
              type="button"
              className="px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50 cursor-pointer"
              onClick={() => handleSaveStatePayload(application)}
            >
              Kaydet
            </button>
          </div>
        </div>
      </Modal>
    </div>
  ) : null
}

export default EditStatePayload
